// extracted by mini-css-extract-plugin
module.exports = {"instructorCard":"style-module__instructorCard___6CLsF"};